<div class="table-responsive">
    <table class="table table-sm">
        <thead class="small">
            <tr>
                <th>A.Y.</th>
                <th>Eli. Stu.</th>
                <th>Gr. Sel.</th>
                <th>Nt. Sel.</th>
                <th>% Sel.</th>
            </tr>
        </thead>
        <tbody class="small">
            <tr>
                <td>2024-25</td>
                <td>185</td>
                <td>307</td>
                <td>171</td>
                <td>92.43</td>
            </tr>
            <tr>
                <td>2023-24</td>
                <td>171</td>
                <td>206</td>
                <td>143</td>
                <td>83.63</td>
            </tr>
            <tr>
                <td>2022-23</td>
                <td>181</td>
                <td>410</td>
                <td>172</td>
                <td>95.03</td>
            </tr>
            <tr>
                <td>2021-22</td>
                <td>122</td>
                <td>316</td>
                <td>121</td>
                <td>99.18</td>
            </tr>
            <tr>
                <td>2020-21</td>
                <td>120</td>
                <td>240</td>
                <td>115</td>
                <td>95.83</td>
            </tr>
        </tbody>
    </table>
</div>
 
